import React, { useMemo, useEffect } from 'react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types'
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import messages from './ContactAgentPage.messages';
import metadata from './ContactAgentPage.metadata.json5';
import styles from './ContactAgentPage.module.scss';
import usecpmiAnalytics from '../../../../../account-management/src/hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../../../../account-management/src/hooks/useGoogleAnalytics';

function ContactAgentPage(props) {
    const {
        match: {
            params: { claimNumber }
        }
    } = props;
    const redirectPath= '/claims';
    const translator = useTranslator();
    const phoneNumber= '1-800-231-1363';
    const [ trackPageView]= usecpmiAnalytics();
    const [trackGAPageView]=useGoogleAnalytics();

    useEffect(() => {
        trackPageView("Contact Agent","/contact-agent/claimNumber")
    },[]);

    useEffect(() => {
        trackGAPageView("/contactAgent/claimNumber","Contact Agent")
    },[])

    const phoneNumberLink = useMemo(() => {
        const phoneLink = `tel:${phoneNumber}`;
        return (
            <a href={phoneLink} className={styles.buttonLinkStyleRemove}>
                {phoneNumber}
            </a>
        );
    }, [phoneNumber]);

    const getText=()=>{
        return(
            <span>
                Please call one of our agents at <span className={styles.boldText}>1-800-231-1363</span> for assistance with submitting your claim.
               
            </span>
        )
    }

    const overrides = {
        callButtonID: {
            content: phoneNumberLink
        },
        callForAssistance: {
            content: getText()
        },
        claimReferenceNumber: {
            visible: !!claimNumber,
            content: translator(messages.claimReferenceNumber, { num: claimNumber })
        },
        link: {
            to: {
                pathname: redirectPath
            }
        }
    };
    const resolvers = {
        resolveClassNameMap: styles
    };

    return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
}
ContactAgentPage.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            state: PropTypes.shape({
                redirectPath: PropTypes.string.isRequired
            }).isRequired
        }).isRequired,
        push: PropTypes.func
    }).isRequired
};

export default withRouter(ContactAgentPage);
